export class ReadaptacaoAlteradaResponseDTO {
  public wasDadosAlterados: boolean;
  public usuarioVisualizouAlerta: boolean;
  public tipoReadaptacao: string;

  constructor(obj: any) {
    if (obj) {
      this.wasDadosAlterados = obj.wasDadosAlterados ?? false;
      this.usuarioVisualizouAlerta = obj.usuarioVisualizouAlerta ?? false;
      this.tipoReadaptacao = obj.tipoReadaptacao ?? '';
    }
  }
}
